/**
 * User Reducers
 */

export default (state = [], action) => {
    switch (action.type) {
        case 'USER_LOGIN':
        case 'USER_LOGOUT':
                console.log(state);
             return Object.assign({}, state, {
                 username: action.username,
                 authenticated: action.authenticated

             })
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/Reducers/User.js